/**
 * 再帰的にnullableな値をnullに変換したオブジェクトを返す
 * @param input
 * @returns
 */
export const nullableValueToNull = (input: unknown): unknown => {
	const copy = structuredClone(input);
	if (copy == null) return null;
	if (Array.isArray(copy)) {
		return copy.map((item) => nullableValueToNull(item));
	}
	if (typeof copy === "object") {
		const entries = Object.entries(copy).map(([key, value]) => [key, nullableValueToNull(value)]);
		return Object.fromEntries(entries);
	}
	return copy;
};
